import { PERMISSIONS } from "@/services/permission"

export default [
  {
    path: "/category/list",
    name: "CategoryOverview",
    component: () => import("@/views/category/CategoryOverview"),
    meta: {
      title: "nav.category.overview",
      requiresAllPermissions: [PERMISSIONS.VIEW_CATEGORY_GENERAL],
      requiresAuth: true,
    },
  },
  {
    path: "/category/create",
    name: "CategoryCreate",
    component: () => import("@/views/category/CategoryCreate"),
    meta: {
      title: "category.create.title",
      requiresAllPermissions: [PERMISSIONS.EDIT_CATEGORY_GENERAL],
      requiresAuth: true,
    },
  },
  {
    path: "/category/:categoryId",
    name: "CategoryDetail",
    props: true,
    component: () => import("@/views/category/CategoryDetail"),
    meta: {
      title: "nav.category.overview",
      requiresAllPermissions: [PERMISSIONS.VIEW_CATEGORY_GENERAL],
      requiresAuth: true,
    },
  },
]
